<cyno-tabset customClass="tabset tabset--dark">
    <cyno-tab tabTitle="Wel verzekerd" [active]="true">
        <p>
            Wij vergoeden schade door ruitbreuk aan glas in uw woning en tuin. Onder glas verstaan wij ook kunststof.
            Verzekerd is bijvoorbeeld schade aan glas in ramen, dakramen, deuren en koepels van uw woning, inclusief
            douchewanden, douchedeuren, douchecabines, licht doorlatende dakplaten, lichtkoepels en glazen deuren. Dat
            geldt ook voor glas in hobbykassen (van maximaal 6 m2) en glas dat dient als terreinafscheiding.
        </p>
        <!-- prettier-ignore -->
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance"
                          pdfLinkTitle="Voorwaarden Woonverzekering">in onze voorwaarden</ins-pdf-link>.
        </p>
    </cyno-tab>
    <cyno-tab tabTitle="Niet verzekerd">
        <p>Schade aan glas in de volgende situaties vergoeden wij niet:</p>
        <list-flat icon="dot" [svg]="true">
            <list-flat-item>Ruitbreuk tijdens de bouw en aan- of verbouw van uw woning</list-flat-item>
            <list-flat-item>
                Lekkage van dubbel glas (condensvorming) zonder dat er sprake is van ruitbreuk
            </list-flat-item>
            <list-flat-item>
                Ruitbreuk van uithangborden, tuinoverkappingen, zonnepanelen, zonnecollectoren en kunstobjecten
            </list-flat-item>
            <list-flat-item>Kassen groter dan 6 m2</list-flat-item>
            <list-flat-item>
                Schade aan glas-in-lood en draadglas, als dat komt door een fout in het glas
            </list-flat-item>
        </list-flat>
        <!-- prettier-ignore -->
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance"
                          pdfLinkTitle="Voorwaarden Woonverzekering">in onze voorwaarden</ins-pdf-link>.
        </p>
    </cyno-tab>

    <cyno-tab tabTitle="Verzekerde bedragen">
        <h2>Verzekerde bedragen</h2>
        <p>Voor normaal glas geldt geen maximaal verzekerd bedrag.</p>
        <p>Voor bijzonder glas geldt een vergoeding van maximaal € 500. Bijzonder glas is onder andere:</p>
        <list-flat icon="dot" [svg]="true">
            <list-flat-item>Glas dat gebrandschilderd, versierd, geëtst of gebogen is</list-flat-item>
            <list-flat-item>Glas-in-lood</list-flat-item>
            <list-flat-item>Versieringen, beschilderingen, opschriften en folie op het glas</list-flat-item>
            <list-flat-item>Glas in terrein- en balkonafscheidingen en kassen</list-flat-item>
        </list-flat>
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
            <a [href]="documentsEnum.ConditionsHomeInsurance" rel="nofollow" target="_blank">in onze voorwaarden</a>.
        </p>
    </cyno-tab>

    <cyno-tab tabTitle="Eigen Risico">
        <p>
            Bij onze Glasverzekering is het eigen risico €&nbsp;0. Als u bij uw Woonverzekering gekozen heeft voor een hoger
            eigen risico in ruil voor een lagere premie, heeft dat geen invloed op de premie en het eigen risico van de
            Glasverzekering.
        </p>
    </cyno-tab>
</cyno-tabset>
